import React from "react";
import { useTranslation } from "react-i18next";
import { useDownloadVersion } from "../../hooks/useDownloadVersion";
import { trackEvent } from "../../lib/analytics";

const MAC_URL = "/api/download/mac";
const WIN_URL = "/api/download/windows";

export default function DownloadPage() {
  const versionInfo = useDownloadVersion();
  const { t } = useTranslation("dashboard");
  return (
    <div>
      <img src="/trapman-wordmark.png" alt="TrapMan" className="h-12 w-auto invert mb-6" />
      <div className="flex items-baseline gap-3 mb-6">
        <h1 className="font-clash text-2xl font-bold text-white">{t("download.heading")}</h1>
        {versionInfo?.version && (
          <span className="font-mono text-xs uppercase tracking-wider text-[#A1A1AA]">
            v{versionInfo.version}
          </span>
        )}
      </div>

      <div className="feature-card rounded-lg p-8 mb-4">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <h2 className="font-clash text-xl text-white">{t("download.macTitle")}</h2>
            <p className="text-sm text-[#A1A1AA] mt-1">
              {t("download.macDesc")}
            </p>
          </div>
          <a
            href={MAC_URL}
            onClick={() => trackEvent("file_download", { platform: "mac", page: "dashboard" })}
            className="btn-primary px-8 py-3 rounded text-sm font-semibold"
          >
            {t("download.macButton")}
          </a>
        </div>
      </div>

      <div className="feature-card rounded-lg p-8">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <h2 className="font-clash text-xl text-white">{t("download.winTitle")}</h2>
            <p className="text-sm text-[#A1A1AA] mt-1">
              {t("download.winDesc")}
            </p>
          </div>
          <a
            href={WIN_URL}
            onClick={() => trackEvent("file_download", { platform: "windows", page: "dashboard" })}
            className="btn-primary px-8 py-3 rounded text-sm font-semibold"
          >
            {t("download.winButton")}
          </a>
        </div>
      </div>
    </div>
  );
}
